import httpClient from './httpClient'

export const login = async (payload) => {
  const endpoint = '/refusers/login'
  return httpClient.put(endpoint, payload)
}
export const getUserProfile = async (payload) => {
  const endpoint = '/refusers/getuserprofile'
  return httpClient.get(endpoint)
}

export const changePassword = async (payload) => {
  const endpoint = '/refusers/ChangePassword/'
  return httpClient.put(endpoint, { id: payload.id , currentPassword: payload.currentPassword, newPassword: payload.newPassword }) 
}

export const forgotPasswordMail = async (payload) => {
  const endpoint = '/refusers/forgottenPasswordMail/'
  return httpClient.put(endpoint, { mail: payload })
}

export const forgotPassword = async (payload) => {
  const endpoint = '/refusers/ForgottenPassword/'
  return httpClient.put(endpoint, { guid: payload.guid, password: payload.password })
}

export default {
  login,
  changePassword,
  forgotPasswordMail,
  forgotPassword,
  getUserProfile
}
